import React, { Fragment, useState } from 'react'
import styles from './ProjectDashboardStyles'
import { Loader, Header, Icon, Popup } from 'semantic-ui-react'
import VideosList from 'Pages/Videos/List'
import ProjectEdit from 'Pages/Projects/Edit'
import SideBarRight from 'Components/SideBarRight'
import { DateTime } from 'luxon'

export default function ProjectDashboard(props) {
  const [isSettingsDisplay, setSettingsDisplay] = useState(false)
  const toggleSettingsDisplay = () => setSettingsDisplay(!isSettingsDisplay)
  const isSideBarVisible = props.rightSideBarVisible
  const projectUpdatedOn = DateTime.fromISO(props.activeProject.updatedAt)

  return (
    <Fragment>
      <Header as='h2' style={{background: '#fff', margin: '0'}}>
        <Header.Content className={styles.header}>
          {props.activeProject.title}
          <Popup inverted size='mini' position='right center'
            trigger={
              <Icon name={getIconName(isSettingsDisplay)}
                    color='yellow'
                    onClick={toggleSettingsDisplay} />
            }
            content={isSettingsDisplay ? 'Project' : 'Settings'}/>
          <Header.Subheader>
            {props.activeProject.videosCount} videos
            <span className={styles.seperator}>•</span>
            Last updated on {projectUpdatedOn.toLocaleString(DateTime.DATE_MED)}
          </Header.Subheader>
        </Header.Content>
      </Header>
      <Loader active={props.fetching} />
      <div className={styles.viewContainer}>
        <div className={styles.videoList(isSettingsDisplay, isSideBarVisible)}>
          <VideosList {...props} />
        </div>
        <div className={styles.rightSideBar(isSettingsDisplay, isSideBarVisible)}>
          <SideBarRight {...props} />
        </div>
        <div style={{display: isSettingsDisplay ? 'block' : 'none'}}>
          <ProjectEdit {...props} />
        </div>
      </div>
    </Fragment>
  )
}

function getIconName(isSettingsDisplay) {
  return isSettingsDisplay ? 'arrow alternate circle left outline' : 'setting'
}



// WEBPACK FOOTER //
// ./src/Pages/Home/ProjectDashboard.js